module.exports = __webpack_public_path__ + "img/ball-triangle.e7a4d46e.svg";